import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { store, persistor } from './store';
import { PersistGate } from 'redux-persist/integration/react';
import reportWebVitals from './reportWebVitals';
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router } from "react-router-dom";
import i18n from './multiLingual';
import { Toaster } from 'react-hot-toast'; // ✅ import default Toaster
import * as Sentry from "@sentry/react";
if (process.env.NODE_ENV === "development") {
  import("@locator/runtime").then(({ setup }) => {
    setup();
  });
}

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.5,
    environment: process.env.NODE_ENV,
    // debug: true, // 👈 VERY IMPORTANT
  });

  // console.log("✅ Sentry initialized successfully");
} else {
  console.error("❌ Sentry DSN is missing!");
}

// 🔍 Test Sentry immediately
Sentry.captureMessage("Sentry test message from app start");
const originalFetch = window.fetch;

window.fetch = async (...args) => {
  try {
    const response = await originalFetch(...args);

    if (!response.ok) {
      const error = new Error(`API Error: ${response.status}`);
      error.response = response;
      Sentry.captureException(error);
    }

    return response;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
};
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      {/* <React.StrictMode> */}
        <Router>
        <Sentry.ErrorBoundary fallback={"Something went wrong"}>
          <App />
          </Sentry.ErrorBoundary>
          {/* <Toaster /> ✅ Default Toaster */}
        </Router>
      {/* </React.StrictMode> */}
    </PersistGate>
  </Provider>
);

reportWebVitals();
